import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { refreshToken } from 'features/user'
import { useAbility } from 'providers/casl'
import { RootState } from 'providers/redux'
import { UseRefreshToken } from './types'

export const useRefreshToken = (): UseRefreshToken => {
  const [loading, setLoading] = useState<boolean>(false)
  const [tried, setTried] = useState<boolean>(false)
  const { t } = useTranslation('providers/tanstackQuery')
  const ability = useAbility()

  const { user } = useSelector((state: RootState) => state.user)

  useEffect(() => {
    const tryToRefreshToken = async () => {
      setLoading(true)

      await refreshToken(ability)
        .then(() => {
          setLoading(false)
          setTried(true)
        })
        .catch(() => {
          throw Error(t('error.unableToRefreshToken'))
        })
    }

    if (user === null && tried === false) {
      tryToRefreshToken()
    }
  }, [user, tried])

  return { loading, tried, user }
}
